import { EVENT_TYPES } from ".";
import { logActivity } from "utils";

export const collaborationCalculationScore = ({
  dataTrackEvent,
  setDiscussionAnalysis,
  setIsAnalysisLoading,
  setShowDiscussionAnalyzed,
  hasAnalysisDataRef,
  sessionContext = {},
}) => {
  if (dataTrackEvent.event_type !== EVENT_TYPES.COLLABORATION_CALCULATION_SCORE) {
    return;
  }

  try {
    const { final_level: level, badge_title: badgeTitle } = dataTrackEvent.data || {};
    if (level === undefined || level === null) {
      return;
    }

    const badgeType = "Teamwork";

    logActivity("Collaboration calculation score received", {
      activityType: "consensus",
      collaborationLevel: level,
      badgeTitle,
      badgeType,
      ...sessionContext,
    });

    setDiscussionAnalysis((prev) => ({
      ...(prev || {}),
      level,
      badgeTitle,
      badgeType,
    }));

    setIsAnalysisLoading(false);
    setShowDiscussionAnalyzed(true);
    hasAnalysisDataRef.current = true;
  } catch (error) {
    console.error("Error handling collaboration calculation score:", error, dataTrackEvent);
  }
};
